import { useQuery } from "@tanstack/react-query";

import { getServiceLines } from "@/src/requests/service-lines";

export const SERVICE_LINES_CACHE_KEY = "service-lines";

export function useServiceLines() {
  return useQuery({
    queryKey: [SERVICE_LINES_CACHE_KEY],
    queryFn: getServiceLines,
    staleTime: Infinity,
    gcTime: Infinity,
  });
}
